// extracted by mini-css-extract-plugin
export default {"content":"textBanner_content__aFyPQ","title":"textBanner_title__Uz5V0","text":"textBanner_text__sNyrS"};